import { useNetworksStateContext } from "../contexts/NetworksContext"

export function useGetNetworkModules() {

    const { selectedNetwork, selectedSubNetworkSlugs } = useNetworksStateContext()

    return selectedNetwork?.children?.length
        ? selectedNetwork.children
            .filter(child => selectedSubNetworkSlugs.includes(child.slug))
            .flatMap(child => child.modules)
        : selectedNetwork?.modules
}